import AnimatedScroll from './animated_scroll'

export default AnimatedScroll